import React from 'react';

export const IconCreateBlack = () => {
  return (
    <span className="icon-svg IconCreateBlack">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs />
        <path
          d="M6.045,13.412a5.088,5.088,0,0,1,.776-.063,4.475,4.475,0,0,1,.783.071v-6.6A1,1,0,0,1,8.74,5.7h3.322V9.965a1.482,1.482,0,0,0,1.684,1.684h4.2v6.785a1,1,0,0,1-1.136,1.112H11.835a4.365,4.365,0,0,1-.6,1.567h5.711a2.286,2.286,0,0,0,2.554-2.578V11.422a2.694,2.694,0,0,0-.823-2.3l-4.1-4.16a2.62,2.62,0,0,0-2.2-.83H8.6A2.292,2.292,0,0,0,6.045,6.721Zm7.38-3.6V5.906l4.309,4.372H13.9C13.566,10.278,13.425,10.137,13.425,9.816Zm-6.6,12.723A4.039,4.039,0,1,0,2.794,18.5,4.076,4.076,0,0,0,6.829,22.539ZM4.267,18.5a.508.508,0,0,1,.541-.533H6.288V16.483a.541.541,0,0,1,1.081,0v1.481H8.85a.537.537,0,0,1,0,1.073H7.369v1.489a.541.541,0,0,1-1.081,0V19.037H4.807A.51.51,0,0,1,4.267,18.5Z"
          transform="translate(1.207 -1.135)"
        />
        <rect className="a" width="24" height="24" style={{ fill: 'none' }} />
      </svg>
    </span>
  );
};
